export type RosterMeta = {
  source: string;
  asOf: string | null;
  snapshot: boolean;
  stale: boolean;
};

export function parseRosterMeta(value: unknown): RosterMeta | null {
  if (typeof value !== 'object' || value === null) return null;
  const meta = value as Record<string, unknown>;
  if (typeof meta.snapshot !== 'boolean') return null;
  if (meta.asOf !== undefined && typeof meta.asOf !== 'string') return null;
  return {
    source: typeof meta.source === 'string' ? meta.source : '',
    asOf: typeof meta.asOf === 'string' ? meta.asOf : null,
    snapshot: meta.snapshot,
    stale: meta.stale === true,
  };
}

export function rosterAsOfLabel(meta: RosterMeta | null | undefined): string | null {
  if (!meta || !meta.snapshot || meta.asOf === null) return null;
  const date = new Date(meta.asOf);
  if (Number.isNaN(date.getTime())) return null;
  const month = date.toLocaleDateString('en-US', { month: 'long', timeZone: 'UTC' });
  const day = String(date.getUTCDate()).padStart(2, '0');
  const label = `Roster from Flashlight360 as of ${month} ${day}, ${date.getUTCFullYear()}`;
  return meta.stale ? `${label} · refresh pending` : label;
}
